import apiService from '../Api'
import { IEventCoupon, IEventCouponCreatePayload, IEventCouponFilter, IEventCouponUpdatePayload } from './interfaces'

export default class EventCouponService {
  async list(filter: IEventCouponFilter): Promise<{ total: number; data: IEventCoupon[] }> {
    const params = new URLSearchParams()
    params.append('search', filter.search)
    params.append('page', filter.page.toString())
    params.append('page_size', filter.page_size.toString())
    if (filter.event_id !== '') params.append('event_id', filter.event_id.toString())
    if (filter.applicant_name) params.append('applicant_name', filter.applicant_name)
    if (filter.commission_type) params.append('commission_type', filter.commission_type)
    if (filter.ticket_id) params.append('ticket_id', filter.ticket_id.toString())
    if (filter.is_active === true || filter.is_active === false) {
      params.append('is_active', filter.is_active ? '1' : '0')
    }
    return apiService.get('/coupons', { params }).then((r) => r.data)
  }

  async create(data: IEventCouponCreatePayload): Promise<IEventCoupon> {
    return apiService.post('/coupons', data).then((r) => r.data)
  }

  async update(id: number, data: IEventCouponUpdatePayload): Promise<IEventCoupon> {
    return apiService.put(`/coupons/${id}`, data).then((r) => r.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/coupons/${id}`)
  }

  async toggleStatus(id: number): Promise<IEventCoupon> {
    return apiService.patch(`/coupons/${id}/toggle-status`).then((r) => r.data)
  }

  async listApplicants(eventId?: number | 'global' | ''): Promise<string[]> {
    const params = new URLSearchParams()
    if (eventId !== undefined && eventId !== '' && eventId !== 'global') {
      params.append('event_id', eventId.toString())
    }
    return apiService.get('/coupons/applicants-for-select', { params }).then((r) => r.data)
  }
}
